const API_URL = process.env.REACT_APP_API_URL_BASE;
const X_API_KEY = process.env.REACT_APP_X_API_KEY;

const buildHeaders = (token, withBody = false) => {
  const headers = {
    Authorization: `Bearer ${token}`,
    "x-api-key": X_API_KEY,
  };
  if (withBody) {
    headers["Content-Type"] = "application/json";
  }
  return headers;
};

export const getAnnouncementsOverview = async token => {
  if (!token) {
    return { count: 0, unread_count: 0, results: [] };
  }

  const response = await fetch(`${API_URL}announcements/overview/`, {
    method: "GET",
    mode: "cors",
    headers: buildHeaders(token),
  });

  if (!response.ok) {
    throw new Error("Failed to load announcements");
  }

  return response.json();
};

export const markAnnouncementRead = async (token, announcementId) => {
  if (!token || !announcementId) return;

  const response = await fetch(`${API_URL}announcements/${announcementId}/read/`, {
    method: "POST",
    mode: "cors",
    headers: buildHeaders(token, true),
    body: JSON.stringify({}),
  });
  if (!response.ok) {
    throw new Error(`Failed to mark announcement as read (${response.status})`);
  }
};

export const dismissAnnouncement = async (token, announcementId) => {
  if (!token || !announcementId) return;

  const response = await fetch(`${API_URL}announcements/${announcementId}/dismiss/`, {
    method: "POST",
    mode: "cors",
    headers: buildHeaders(token, true),
    body: JSON.stringify({}),
  });
  if (!response.ok) {
    throw new Error(`Failed to dismiss announcement (${response.status})`);
  }
};

export const dismissAllAnnouncements = async token => {
  if (!token) return;

  const response = await fetch(`${API_URL}announcements/dismiss_all/`, {
    method: "POST",
    mode: "cors",
    headers: buildHeaders(token, true),
    body: JSON.stringify({}),
  });
  if (!response.ok) {
    throw new Error(`Failed to dismiss all announcements (${response.status})`);
  }
};


export const decodeHtmlEntities = value => {
  if (!value) return "";
  const textarea = document.createElement("textarea");
  textarea.innerHTML = value;
  return textarea.value;
};

export const normalizeAnnouncementHtml = value =>
  decodeHtmlEntities(value)
    .replace(/<(p|div)>\s*(?:&nbsp;|\u00a0|<br\s*\/?>|\s)*<\/\1>/gi, "")
    .replace(/(?:<br\s*\/?>\s*){3,}/gi, "<br /><br />")
    .trim();

export const renderAnnouncementHtml = body => ({
  __html: normalizeAnnouncementHtml(body),
});

export const getAnnouncementId = announcement => announcement?.id || null;

export const getAnnouncementAuditMetadata = (announcement, action) => {
  const now = new Date().toISOString();
  return {
    entity_type: "announcement",
    action,
    announcement_id: getAnnouncementId(announcement),
    title: announcement?.title || null,
    body: announcement?.body || null,
    created_at: announcement?.created || null,
    ...(action === "read" ? { read_at: now } : {}),
    ...(action === "dismiss" ? { dismissed_at: now } : {}),
  };
};

/** Fired when announcement read/dismiss state changes elsewhere (e.g. announcements table). */
export const ANNOUNCEMENTS_CHANGED_EVENT = "mmd-announcements-changed";

export const notifyAnnouncementsChanged = () => {
  if (typeof window !== "undefined") {
    window.dispatchEvent(new CustomEvent(ANNOUNCEMENTS_CHANGED_EVENT));
  }
};
